import {UsuarioDetalhes} from "../../auth/models/usuario-detalhes";

export class EmpresaDetalhes {
  quantidadeUsuarioPlano: number;
  quantidadeUsuarioUtilizado: number;
  quantidadeProcessoMonitoradosPlano: number;
  quantidadeProcessoMonitoradosUtilizado: number;
  espacoDocumentosPlano: number;
  espacoDocumentosUtilizado: number;
  nomePlano: string;
  valor: number;
  dataValidade: Date;
  usuarioResponsavel: UsuarioDetalhes;
}
